var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { classNames } from 'libs/react';
import { useDebounce } from 'libs/react';
import { useEffect } from 'libs/react';
import { useQuery } from 'libs/react';
import { useState } from 'libs/react';
import { FormInput } from './FormInput';
import { useApolloClient, useMutation } from '@apollo/client';
import { Button } from 'components/Button';
import { Icon } from 'components/Icon';
import { Image } from 'components/Image';
import { Text } from 'components/Text';
import { Case } from 'components/util/Case';
import { Else } from 'components/util/Else';
import { When } from 'components/util/When';
import { Waiter } from 'components/Waiter';
import { React } from 'libs/react';
import { CreateEntityFromAssetMutation } from 'graphql/Asset/mutations/CreateEntityFromAssetMutation';
import { ClientQuery } from 'graphql/Client/queries/ClientQuery';
import { ContactQuery } from 'graphql/Contact/queries/ContactQuery';
import { asset } from 'libs/asset';
import { FormInputPickerModal } from './FormInputPickerModal';
import { useAccount } from 'components/account/AccountProvider';
import './FormInputPicker.scss';
/**
 * @component FormInputPicker
 * @since 1.0.0
 */
export function FormInputPicker(props) {
    var _a;
    const { name, type, size, style, picto, badge, clearable, creatable, createLabel, hasModalPicker, label, tooltip, infos, value, required, optional, disabled, noResultsLabel, placeholder, prefix, singlePick, suffix, query, queryOptions, limit, format, idsToExclude, objectType, externalQuery, externalObjectType, entity, values } = Object.assign({ type: 'text', size: 'medium', name: '', style: 'normal', picto: 'magnifying-glass', limit: 1000, objectType: '', externalObjectType: '', createLabel: t('Create'), noResultsLabel: t('No results found'), hasModalPicker: true }, props);
    const account = useAccount();
    const hasExternalSearch = ((_a = account.options) === null || _a === void 0 ? void 0 : _a.externalSearch) === 'true';
    const EXTERNAL_SEARCH_MIN_LENGTH = 3;
    const apolloClient = useApolloClient();
    const [inputValue, setInputValue] = useState('');
    const [search, setSearch] = useState('');
    const [skipFetching, setSkipFetching] = useState(true);
    const [opened, setOpened] = useState(false);
    const [openFormInputPickerModel, setOpenFormInputPickerModel] = useState(false);
    const setSearchDebounced = useDebounce(setSearch, 500);
    const trimmedSearch = search.trim();
    const trimmedInputValue = inputValue.trim();
    const canSearchExternal = hasExternalSearch && trimmedSearch.length >= EXTERNAL_SEARCH_MIN_LENGTH;
    const showExternalMinLengthHint = hasExternalSearch &&
        !!externalQuery &&
        trimmedInputValue.length > 0 &&
        trimmedInputValue.length < EXTERNAL_SEARCH_MIN_LENGTH;
    const input = {};
    input.search = search;
    input.limit = limit;
    if (queryOptions) {
        Object.entries(queryOptions).forEach(([key, value]) => (input[key] = value));
    }
    if (objectType === 'saleItems' && input.active == null) {
        input.active = true;
    }
    const [data, ready] = useQuery(query, {
        variables: {
            input: input
        },
        skip: skipFetching,
        fetchPolicy: 'network-only'
    });
    let externalData;
    let externalReady = false;
    if (externalQuery && hasExternalSearch) {
        [externalData, externalReady] = useQuery(externalQuery, {
            variables: {
                input
            },
            skip: !canSearchExternal
        });
    }
    const [mutate] = useMutation(CreateEntityFromAssetMutation);
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        setOpened(false);
        if (props.onBlur) {
            props.onBlur();
        }
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        if (props.onFocus) {
            props.onFocus();
        }
    }
    /**
     * @function clearSearch
     * @since 1.0.0
     * @hidden
     */
    function clearSearch() {
        setInputValue('');
        setSearch('');
        setSearchDebounced('');
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(value) {
        setInputValue(value);
        setSkipFetching(false);
        if (props.onChange) {
            props.onChange(value);
        }
        if (value.trim() === '') {
            setSearch('');
        }
        setSearchDebounced(value);
    }
    /**
     * @function onCreate
     * @since 1.0.0
     * @hidden
     */
    function onCreate() {
        if (props.onCreate) {
            props.onCreate();
        }
        setOpened(false);
    }
    /**
     * @function onItemClick
     * @since 1.0.0
     * @hidden
     */
    function onItemClick(item) {
        if (props.onSelect) {
            props.onSelect(item);
        }
        clearSearch();
    }
    /**
     * @function onExternalItemClick
     * @since 1.0.0
     * @hidden
     */
    function onExternalItemClick(item) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield mutate({
                variables: {
                    input: {
                        id: item.id,
                        asset: item.asset,
                        entity: entity
                    }
                }
            });
            const createdId = (_a = result.data) === null || _a === void 0 ? void 0 : _a.createEntityFromAsset;
            if (createdId && props.onSelect) {
                let selected = {
                    id: createdId,
                    name: item.title,
                    fullname: item.title
                };
                try {
                    if (entity === 'contact') {
                        const { data } = yield apolloClient.query({
                            query: ContactQuery,
                            variables: { input: { id: createdId } },
                            fetchPolicy: 'network-only'
                        });
                        if (data === null || data === void 0 ? void 0 : data.contact) {
                            selected = data.contact;
                        }
                    }
                    else if (entity === 'client') {
                        const { data } = yield apolloClient.query({
                            query: ClientQuery,
                            variables: { input: { id: createdId } },
                            fetchPolicy: 'network-only'
                        });
                        if (data === null || data === void 0 ? void 0 : data.client) {
                            selected = data.client;
                        }
                    }
                }
                catch (_b) {
                    // Fall back to the minimal payload so selection still closes the picker.
                }
                props.onSelect(selected);
            }
            clearSearch();
        });
    }
    /**
     * Opens the menu when there is a search.
     * @since 1.0.0
     */
    useEffect(() => {
        setOpened(trimmedInputValue.length > 0);
    }, [trimmedInputValue]);
    let items = data ? getResult(data, objectType) : [];
    const externalItems = externalData
        ? getResult(externalData, externalObjectType)
        : [];
    if (objectType === 'saleItems') {
        items = items.filter((item) => {
            if (item.deletedAt) {
                return false;
            }
            if (input.active === true && item.active === false) {
                return false;
            }
            return true;
        });
    }
    if (idsToExclude === null || idsToExclude === void 0 ? void 0 : idsToExclude.length) {
        items = items.filter((item) => item.id && !idsToExclude.includes(item.id));
    }
    /**
     * @function onOpenListSelect
     * @since 1.0.0
     */
    function onOpenListSelect() {
        clearSearch();
        setSkipFetching(false);
        setOpenFormInputPickerModel(true);
    }
    /**
     * @function onCloseModal
     * @since 1.0.0
     */
    function onCloseModal() {
        setSkipFetching(true);
        setOpenFormInputPickerModel(false);
    }
    /**
     * @function onSelectComplete
     * @since 1.0.0
     */
    function onSelectComplete(selectedItem) {
        if (props.onSelect) {
            props.onSelect(selectedItem);
        }
        clearSearch();
    }
    /**
     * @function onChangeMany
     * @since 1.0.0
     */
    const onChangeMany = props.onChangeMany
        ? (added, removed) => {
            var _a;
            (_a = props.onChangeMany) === null || _a === void 0 ? void 0 : _a.call(props, added, removed);
            clearSearch();
        }
        : undefined;
    /**
     * @function onRemove
     * @since 1.0.0
     */
    function onRemove(removedItem) {
        if (props.onRemove) {
            props.onRemove(removedItem);
        }
        clearSearch();
    }
    const className = classNames('form-input-picker', 'form-input-picker--' + size, 'form-input-picker--' + style, { 'form-input-picker--is-opened': opened }, { 'form-input-picker--hasModalPicker': hasModalPicker }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(FormInput, { name: name, type: type, size: size, style: style, label: label, infos: infos, picto: picto, badge: badge, value: inputValue, required: required, optional: optional, disabled: disabled, clearable: clearable, placeholder: placeholder, prefix: prefix, suffix: suffix, tooltip: tooltip, onBlur: onBlur, onFocus: onFocus, onChange: onChange }),
        hasModalPicker && (React.createElement("div", { className: "form-input-picker-select" },
            React.createElement(Button, { size: "large", className: "form-input-picker-select-button", picto: "list", onPress: onOpenListSelect }))),
        creatable && (React.createElement("div", { className: "form-input-picker-create" },
            React.createElement(Button, { size: "large", className: "form-input-picker-create-button", picto: "add", onPress: onCreate }))),
        React.createElement("div", { className: "form-input-picker-list" },
            React.createElement("div", { className: "form-input-picker-list-content" },
                React.createElement("div", { className: ready
                        ? 'form-input-picker-list-item-waiter-is-loaded'
                        : 'form-input-picker-list-item-waiter' }),
                React.createElement(Waiter, { until: ready },
                    React.createElement(When, null,
                        React.createElement(Case, { is: items.length }, items.map((item) => {
                            const data = format(item);
                            const infos = [data.category, data.infos]
                                .filter(Boolean)
                                .join(' · ');
                            return (React.createElement("div", { key: data.id, className: "form-input-picker-list-item", onClick: () => onItemClick(item) },
                                React.createElement("div", { className: "form-input-picker-list-item-container" },
                                    React.createElement("div", { className: "form-input-picker-list-item-title" }, data.title),
                                    React.createElement("div", { className: "form-input-picker-list-item-infos", dangerouslySetInnerHTML: { __html: infos } })),
                                React.createElement("div", null,
                                    React.createElement(Icon, { className: "form-input-picker-list-item-picto", value: "plus" }))));
                        })),
                        React.createElement(Else, null,
                            React.createElement("div", { className: "form-input-picker-list-empty" }, noResultsLabel)))),
                externalQuery && hasExternalSearch && showExternalMinLengthHint && (React.createElement("div", { className: "form-input-picker-list-empty" }, t('Type at least 3 characters to search external assets.'))),
                externalQuery && hasExternalSearch && canSearchExternal && (React.createElement(Waiter, { until: externalReady },
                    React.createElement(When, null,
                        React.createElement(Case, { is: externalItems.length }, externalItems.map((item) => {
                            const data = format(item);
                            return (React.createElement("div", { key: data.id, className: "form-input-picker-list-item", onClick: () => onExternalItemClick(data) },
                                React.createElement("div", { className: "form-input-picker-list-item-container" },
                                    React.createElement("div", { className: "form-input-picker-list-item-title" },
                                        React.createElement(Text, { value: data.title }),
                                        React.createElement(Image, { className: "form-input-picker-list-item-title-picto", source: asset('images/assets/' + data.asset + '.jpg') })),
                                    React.createElement("div", { className: "form-input-picker-list-item-infos" }, data.infos)),
                                React.createElement("div", null,
                                    React.createElement(Icon, { className: "form-input-picker-list-item-picto", value: "plus" }))));
                        })),
                        React.createElement(Else, null,
                            React.createElement("div", { className: "form-input-picker-list-empty" }, t('No results found in external asset.')))))),
                creatable && (React.createElement("div", { className: "form-input-picker-list-item-create" },
                    React.createElement(Button, { className: "form-input-picker-list-item-create-button", picto: "add", label: createLabel, onPress: onCreate }))))),
        openFormInputPickerModel && (React.createElement(FormInputPickerModal, { items: items, format: format, onClose: onCloseModal, onCreate: onCreate, onRemove: onRemove, onSelect: onSelectComplete, onChangeMany: onChangeMany, partnerFilter: objectType === 'saleItems', ready: ready, title: typeof label === 'string' ? label : undefined, singlePick: singlePick, creatable: creatable, values: values }))));
}
/**
 * @function getResult
 * @since 1.0.0
 * @hidden
 */
function getResult(data, objectType) {
    const keys = Object.keys(objectType ? data[objectType] : data);
    if (keys.length) {
        if (objectType) {
            return data[objectType].items;
        }
        else {
            return data[keys[0]];
        }
    }
    return [];
}
